import axios from 'axios'

export const mutations = {
  customerRefresh (state, customers) {
    state.all = customers
    console.log('refresh customers')
  },
  customerExtend (state, customer) {
    console.log('extend customer')
    state.all.push(customer)
  },
  customerEdit (state, customerToEdit) {
    console.log('edit customer')
    state.editing = state.all.find((customer) => { // returns the value of the first element that satisfies the condition
      return customer._id === customerToEdit
    })
  },
  customerCancelEdit (state) {
    console.log('cancel edit customer')
    state.editing = undefined
  },
  customerCreate (state) {
    console.log('create customer')
    state.editing = { // default value
      'name': '',
      'customId': '',
      'address': {
        'street': '',
        'postcode': '',
        'city': '',
        'country': 'LU'
      },
      'contact': {
        'name': '',
        'email': '',
        'phone': '',
        'fax': ''
      },
      'users': [],
      'productList': '',
      'note': ''
    }
  },
  customerUpdateOne (state, updated) {
    console.log('update one customer')
    if (state.all.length === 0) {
      state.all.push(updated)
    } else {
      state.all = state.all.map(customer => { // replace the only updated customer, others are intact
        return customer._id === updated._id ? updated : customer
      })
    }
  },
  customerToDelete (state, customerToDelete) {
    console.log('customer to delete')
    state.deleting = state.all.find((customer) => {
      return customer._id === customerToDelete._id
    })
  },
  customerDeleted (state) {
    console.log('cancel deleted')
    state.all = state.all.filter((value) => { return value._id !== state.deleting._id }) // filter out the deleted customer
    state.deleting = undefined
  },
  customerCancelDelete (state) {
    console.log('cancel delete customer')
    state.deleting = undefined
  }
}

export const actions = {
  // ========================================
  fetchCustomers: async ({ commit }) => {
    try {
      let customers = await axios.get('/api/v1/customers')
      commit('customerRefresh', customers.data)
    } catch (err) {
      commit('customerRefresh', [])
    }
  },
  // ========================================
  fetchCustomersByUser: async ({ commit, state }, userEmail) => {
    try {
      console.log('run fetchCustomersByUser')
      let customers = await axios.get('/api/v1/customers/' + userEmail)
      commit('customerRefresh', customers.data)
    } catch (err) {
      console.log(err)
    }
  },
  // ========================================
  saveCustomer: async ({ commit, state }) => {
    console.log('run saveCustomer')
    try {
      if (state.editing._id !== undefined) {
        // Update existing customer
        await axios.put('/api/v1/customers/' + state.editing._id, state.editing)
        commit('customerUpdateOne', state.editing)
      } else {
        // Add new customer
        let response = await axios.post('/api/v1/customers', state.editing)
        commit('customerExtend', response.data) // insert a new customer also with its _ID
      }
      commit('customerCancelEdit')
    } catch (err) {
      console.log(err)
    }
  },
  // ========================================
  deleteCustomers: async ({ commit, state }) => {
    console.log('run deleteCustomers', state.deleting)
    try {
      await axios.delete('/api/v1/customers/' + state.deleting._id)
      commit('customerDeleted', state.deleting._id)
    } catch (err) {
      console.log(err)
    }
  }
}

export const getters = {
  allCustomers: (state) => {
    return state.all
  },
  editingCustomer: (state) => {
    return state.editing
  }
}

export default {
  state: {
    all: [],
    editing: undefined,
    deleting: undefined
  },
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/Customers.js